module.exports = __webpack_public_path__ + "static/media/1O2A0745.c9608035.jpg";